import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

type HttpMethod = "GET" | "POST" | "PUT" | "DELETE";

export const isSocketCall: boolean = false;

interface HttpCallOptions {
  url: string;
  method: HttpMethod;
  data?: any; // for POST/PUT requests
  headers?: Record<string, string>; // optional headers
  params?: Record<string, any>; // for query parameters
}

export async function httpCall<T>(options: HttpCallOptions): Promise<T> {
  const { url, method, data, headers, params } = options;

  const config: AxiosRequestConfig = {
    url,
    method,
    headers,
    params,
    data, // for POST and PUT requests
  };

  try {
    const response: AxiosResponse<T> = await axios(config);
    return response.data;
  } catch (error) {
    // Handle the error appropriately
    if (axios.isAxiosError(error) && error.response) {
      console.error("API Error:", error.response.data);
      throw error.response.data; // Re-throw to allow handling outside
    } else {
      console.error("Network Error:", error);
      throw new Error("Network error occurred");
    }
  }
}
